import { inject } from '@angular/core';
import { CanActivateFn, Router, type GuardResult, type MaybeAsync} from '@angular/router';
import { UserRole } from '@core-interfaces/global';
import { AuthManager } from '@infra-adapters/services/auth.service';

export const ActiveSessionGuard: CanActivateFn = ( route, state ): MaybeAsync<GuardResult> => {
    const authService = inject(AuthManager);
    const router = inject(Router);
    if (!authService.isAuth()) {
        return true;
    } else {
        const userRole = authService.UserSessionData()!.role;

        if(UserRole.Administrator == userRole){
            return router.navigate(['/home/survey']);
        }

        return router.navigate(['/home/dashboard']);
    }
};
